import {
  CARD_DECK_RADIUS,
  CARD_DECK_SHADOWS,
} from './constants';

export default function PlaceholderDeckCard() {
  return (
    <div
      className="w-full aspect-[382/462] bg-white"
      style={{
        borderRadius: `${CARD_DECK_RADIUS.card}px`,
        boxShadow: CARD_DECK_SHADOWS.card,
      }}
    />
  );
}
